import { ButtonGroup, Button, Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@mui/material';
import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface IEmailLendersActionButtonProps {
    setAll: () => void;
    setActive: () => void;
    setInactive: () => void;
}

type EmailLendersActionItem = keyof typeof EmailLendersItemMap;
const EmailLendersItemMap = {
    All: 'All',
    Active: 'Active',
    Inactive: 'Inactive',
};

export const EmailLendersActionButton: React.FC<IEmailLendersActionButtonProps> = ({ setAll, setActive, setInactive }) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLDivElement>(null);

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const handleClick = (action: EmailLendersActionItem) => {
        switch (action) {
            case 'All':
                setAll();
                break;

            case 'Active':
                setActive();
                break;

            case 'Inactive':
                setInactive();
                break;
        }
    };

    const handleClose = (event: Event) => {
        if (anchorRef.current?.contains(event.target as HTMLElement)) {
            return;
        }
        setOpen(false);
    };

    const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, actionItem: EmailLendersActionItem) => {
        setOpen(false);
        handleClick(actionItem);
    };

    return (
        <>
            <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
                <Button onClick={handleToggle}>Email Lenders</Button>
                <Button
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                >
                    <ArrowDropDownIcon />
                </Button>
            </ButtonGroup>
            <Popper
                open={open}
                style={{ zIndex: 1000, margin: 0 }}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem>
                                    <MenuItem onClick={event => handleMenuItemClick(event, 'All')}>
                                            {EmailLendersItemMap['All']}
                                    </MenuItem>
                                    <MenuItem onClick={event => handleMenuItemClick(event, 'Active')}>
                                            {EmailLendersItemMap['Active']}
                                    </MenuItem>
                                    <MenuItem onClick={event => handleMenuItemClick(event, 'Inactive')}>
                                            {EmailLendersItemMap['Inactive']}
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
};
